import React, { useContext } from 'react'
import { Link } from 'gatsby'
import cart from '../../img/cart.svg'
import styled from 'styled-components'
import reduce from 'lodash/reduce'
import PropTypes from 'prop-types'

import StoreContext from '~/context/StoreContext'

const useQuantity = () => {
  const { store: { checkout } } = useContext(StoreContext)
  const items = checkout ? checkout.lineItems : []
  const total = reduce(items, (acc, item) => acc + item.quantity, 0)
  return [total !== 0, total]
}

const Navigation = ({ siteTitle }) => {
  const [hasItems, quantity] = useQuantity()

  return (
    <CartIconWrapper>
      <Link to='/cart' style={{ position: 'relative' }}>
        {hasItems &&
          <NotificationWrapper>
            <NotificationNumber>
              {quantity}
            </NotificationNumber>
          </NotificationWrapper>}
        <img src={cart} alt='cart-icon' style={{ width: '30px', marginTop: '0.2rem' }} />
      </Link>
    </CartIconWrapper>
  )
}

Navigation.propTypes = {
  siteTitle: PropTypes.string
}

Navigation.defaultProps = {
  siteTitle: ''
}

export default Navigation

const CartIconWrapper = styled.span`
  position: absolute;
  top: 10px;
  right: 0;
  margin-right: 1rem;
`

const NotificationWrapper = styled.span`
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  border: 1px solid #FFF;
  width: 20px;
  text-align: center;
  height: 20px;
  background-color: red;
  position: absolute;
  bottom: 15px;
  left: 20px;
  // font-size: 18px;
  line-height: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  color: #FFF;
`

const NotificationNumber = styled.span`
  display: block;
  font-size: 15px;
`
